module.exports = __webpack_public_path__ + "static/media/ta-grad-04.38b483ed.png";